import { track } from '@farmersdog/analytics';

import { landing_page_email_form_submitted } from '../eventNames';

import type { FormValues } from '../../slices/EmailFormSlice/hooks/useEmailForm';

/**
 * Send a tracking event for when a user submits the email form on breed content pages
 *
 * @param email - The user's email
 * @param petsCount - The user's number of pets selected
 * @param zip - The user's zip code
 * @param firstName - The user's first name
 */

export function trackLandingPageEmailFormSubmitted({
  email,
  petsCount,
  zip,
  firstName,
}: FormValues) {
  track(landing_page_email_form_submitted, {
    email,
    petsCount,
    zip,
    firstName,
  });
}
